import { ORDERS_BLOTTER_PREFIX } from '@src/containers/Blotters/Orders/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy orders tabs into orders blotter panel params. */
export function migrateOrdersBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyOrdersTabs = config.tabs?.[ORDERS_BLOTTER_PREFIX];
  if (legacyOrdersTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyOrdersTabs,
    blotterType: 'ordersBlotter',
  });
}
